module.exports = __webpack_public_path__ + "static/media/android6.ec266c35.jpg";